/**
 *
 * @param {string} value
 * @returns {string}
 */

export function upperCaseFirst(value) {
  const firstChar = value.substring(0, 1);
  const firstCharUpperCase = firstChar.toUpperCase();
  if (firstChar !== firstCharUpperCase) {
    return firstCharUpperCase + value.substring(1);
  }
  return value;
}
